import { BaseAPI } from "../base/service";
import { CourseType, TutoringType } from "../enums";
import { Tutoring } from "./dto";


export class TutoringAPI extends BaseAPI {
    private year: number = new Date().getFullYear();

    public getList(courseType: CourseType, tutoringType: TutoringType): Promise<Tutoring[]> {
        return this.api.get(`${courseType}/${this.year}/tutoring/?tipo=${tutoringType}`);
    }
}